import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmAlertModule, MmButtonModule, MmIconModule, MmTooltipModule } from '@metromarkets/components';
import { BasePageModule } from '~shared/modules/base-page/base-page.module';
import { MediaControlModule } from '~shared/modules/media-control/media-control.module';
import { EmailSentModule } from '~shared/modules/email-sent/email-sent.module';
import { AccountComponent } from './components/account/account.component';
import { HorizontalMenuComponent } from './components/horizontal-menu/horizontal-menu.component';
import { AfterChangeEmailComponent } from './components/after-change-email/after-change-email.component';
import { AccountService } from './services/account.service';
import { AccountRoutingModule } from './account-routing.module';
import { AddressBookModule } from './modules/address-book/address-book.module';
import { AccountManagementModule } from './modules/account-management/account-management.module';
import { AccountSideBarMenuComponent } from './components/account-side-bar-menu/account-side-bar-menu.component';
import { MatTabsModule } from '@angular/material/tabs';
import { AppImpersonationActiveAlertDialogModule } from '~shared/components/impersonation-active-alert-dialog/impersonation-active-alert-dialog.module';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    QaLocatorsModule,
    MmAlertModule,
    MmIconModule,
    MmButtonModule,
    BasePageModule,
    MediaControlModule,
    AddressBookModule,
    AccountManagementModule,
    AccountRoutingModule,
    EmailSentModule,
    MatTabsModule,
    MmTooltipModule,
    AppImpersonationActiveAlertDialogModule,
  ],
  declarations: [
    AccountComponent,
    HorizontalMenuComponent,
    AfterChangeEmailComponent,
    AccountSideBarMenuComponent,
    AccessDeniedComponent
  ],
  providers: [
    AccountService
  ],
})
export class AccountModule {}
